import {
  frictionIndexForWorkingFR,
  sizeReturnDuctByVelocity,
  sizeReturnDuctFromTable
} from '@alpinehomeair/common';
import { DuctSuppliesModeType } from 'utils/duct-supplies';

export type ReturnSplitType = {
  openings: number;
  totalCfm: number;
  plannedOpenings: number;
  plannedSizeIn: number | null;
  mode?: DuctSuppliesModeType;
  workingFR?: number;
};

/** The engine's largest planned return branch, or null with no branches. */
export function largestPlannedSizeIn(
  returns: ReadonlyArray<{ autoSizeIn: number }>
): number | null {
  return returns.length > 0
    ? Math.max(...returns.map((run) => run.autoSizeIn))
    : null;
}

/**
 * Duct size for a return layout that splits `totalCfm` across `openings`.
 * The engine's own layout is authoritative: its size already weighs the 10x9
 * reducer's equivalent length, which a table lookup at the published working
 * FR cannot reproduce. Any other split is sized from the table.
 */
export function returnBranchSizeIn(split: ReturnSplitType): number | null {
  if (split.openings <= 0) return null;
  if (
    split.openings === split.plannedOpenings &&
    split.plannedSizeIn !== null
  ) {
    return split.plannedSizeIn;
  }
  const cfm = split.totalCfm / split.openings;
  if (split.mode === undefined || split.workingFR === undefined) {
    return sizeReturnDuctByVelocity(cfm);
  }
  return sizeReturnDuctFromTable(
    cfm,
    split.mode,
    frictionIndexForWorkingFR(split.workingFR)
  );
}
